module.exports = __webpack_public_path__ + "static/media/8.Highlighted Spread.a6b12073.jpg";